import { computed, ref } from 'vue';
import { defineStore } from 'pinia';
import type { Data360FilterItem } from 'Types/aemui/find-a-location/findaLocation';

export const useD360MapFiltersStore = defineStore('d360MapFilters', () => {
	const availableFilters = ref<Data360FilterItem[]>([]);
	const selectedFilters = ref<Data360FilterItem[]>([]);

	const filtersCount = computed(() => {
		if (!hasFilters.value) return 0;
		return selectedFilters.value.length;
	});

	const filtersCountDisplay = computed(() => {
		if (!hasFilters.value) return '';
		return `(${filtersCount.value})`;
	});

	const hasFilters = computed(() => {
		return Boolean(selectedFilters.value?.length);
	});

	const clearFilters = () => {
		selectedFilters.value = [];
		updateUrl();
	};

	const isSelected = (filter: Data360FilterItem) =>
		selectedFilters.value.some((x) => x.id === filter.id);

	const loadFromUrl = () => {
		const url = new URL(window.location.href);
		const filters = url.searchParams.getAll('filter');
		filters.forEach((filterFromUrl) => {
			const match = availableFilters.value.find(
				(availableFilter) => availableFilter.id === filterFromUrl
			);
			if (match) {
				selectedFilters.value.push(match);
			}
		});
	};

	const toggleFilter = (payload: Data360FilterItem) => {
		const matchIndex = selectedFilters.value.findIndex((filter) => filter.id === payload.id);
		if (matchIndex >= 0) {
			selectedFilters.value.splice(matchIndex, 1);
		} else {
			selectedFilters.value.push(payload);
		}
		updateUrl();
	};

	const updateUrl = () => {
		const url = new URL(window.location.href);
		url.searchParams.delete('filter');
		selectedFilters.value.forEach((filter) => {
			url.searchParams.append('filter', filter.id);
		});
		window.history.replaceState(null, '', url);
	};

	return {
		availableFilters,
		filtersCount,
		filtersCountDisplay,
		hasFilters,
		selectedFilters,
		clearFilters,
		isSelected,
		loadFromUrl,
		toggleFilter
	};
});
